import MonthlyPayrollView from "./MonthlyPayrollView";
import WeeklyPayrollView from "./WeeklyPayrollView";
import HistoryByDateView from "./HistoryByDateView";
import HistoryByEmployeeView from "./HistoryByEmployeeView";

export default function PayrollStatementView({ data, preview_url }) {
  const format = data?.document_info?.payroll_format;

  switch (format) {
    case "monthly_summary":
      return <MonthlyPayrollView data={data} />;

    case "weekly_summary":
      return <WeeklyPayrollView data={data} />;

    case "history_by_date":
      return <HistoryByDateView data={data} />;

    case "history_by_employee":
      return <HistoryByEmployeeView data={data} />;

    case "history_part1_by_date":
      return <HistoryByDateView data={data} />;

    case "history_part1_by_employee":
      return <HistoryByEmployeeView data={data} />;

     case "excel_gross_to_net":
      return <HistoryByEmployeeView data={data} />;

    default:
      return (
        <div className="alert alert-warning">
          Unsupported payroll format
        </div>
      );
  }
}
